module.exports = __webpack_public_path__ + "static/media/pause.ec539d7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/player-controls/pause.svg
// module id = 630
// module chunks = 0